/* ppz-gallery.js — galleria della scheda prodotto: foto scorrevoli + miniature.
 *
 * Contratto: la sezione porta data-ppz-gallery, dentro ci sono
 *   [data-ppz-gallery-track]  il nastro che scorre (ogni figlio e' una foto)
 *   [data-ppz-gallery-thumbs] la striscia delle miniature
 *   [data-ppz-gallery-thumb]  ogni bottone-miniatura, nell'ordine delle foto
 *
 * Le foto delle confezioni portano data-bundle="1|2|3". Quando la scatola
 * d'acquisto annuncia che si e' scelta una confezione (evento ppz:bundle) le
 * foto si riordinano: prima quella della confezione scelta, poi tutte le
 * altre foto normali, in fondo le foto delle altre confezioni.
 *
 * Per questo foto e miniature NON si tengono in un array fisso: si rileggono
 * dal DOM ogni volta, se no dopo un riordino gli indici puntano al posto
 * sbagliato.
 */
(function () {
  /* I filmati del prodotto ([data-ppz-gallery-video], dal 03/10/2026).
     Stesse regole dei filmati di «Case vere» (ppz-stories-video.js): niente
     controlli del browser, il tasto tondo lo fa partire, un tocco sul filmato
     lo ferma e il tasto ricompare, alla fine torna al primo fotogramma.
     In piu', qui, si ferma da solo quando esce dallo schermo: scorrendo alla
     foto dopo, scendendo nella pagina o scegliendo un'altra confezione. */
  function wireVideos(root, track) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-ppz-gallery-video]'), function (box) {
      var video = box.querySelector('video');
      var play = box.querySelector('[data-ppz-gallery-play]');
      if (!video || !play) return;

      function showPlay() { box.classList.remove('is-playing'); }
      function hidePlay() { box.classList.add('is-playing'); }

      /* Da telefono il filmato puo' essere la foto che spunta dal bordo:
         toccato li' partirebbe quasi tutto fuori dallo schermo, quindi lo si
         porta davanti. Da computer le foto sono una griglia: niente da scorrere. */
      function reveal() {
        if (track.scrollWidth <= track.clientWidth + 1) return;
        var first = track.firstElementChild;
        track.scrollTo({ left: box.offsetLeft - (first ? first.offsetLeft : 0), behavior: 'smooth' });
      }

      function start() {
        hidePlay();
        reveal();
        /* Un filmato con l'audio alla volta: se ne sta andando un altro (quelli
           di «Case vere») lo si ferma. Quelli muti che girano da soli («Cosa
           aspettarsi») non si toccano. */
        Array.prototype.forEach.call(document.querySelectorAll('video'), function (other) {
          if (other !== video && !other.paused && !other.muted) other.pause();
        });
        var p = video.play();
        /* se il browser blocca la riproduzione si torna com'era, invece di
           lasciare il filmato fermo e senza tasto */
        if (p && typeof p.catch === 'function') p.catch(showPlay);
      }

      play.addEventListener('click', start);

      video.addEventListener('click', function () {
        if (video.paused || video.ended) start();
        else video.pause();
      });

      video.addEventListener('play', hidePlay);
      video.addEventListener('pause', function () { if (!video.ended) showPlay(); });
      video.addEventListener('ended', function () {
        video.pause();
        showPlay();
        try { video.currentTime = 0; } catch (e) { /* resta dov'e' */ }
      });

      if (window.IntersectionObserver) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 0.5 && !video.paused) video.pause();
          });
        }, { threshold: [0, 0.5] }).observe(box);
      }

      /* Il carrello si apre a tutta pagina e copre il filmato, ma il filmato
         non si sposta e l'osservatore qui sopra non se ne accorge: lo si ferma
         quando il pannello perde `hidden` (lo toglie apri() in ppz-cart.js). */
      var cart = document.querySelector('[data-ppz-cart]');
      if (cart && window.MutationObserver) {
        new MutationObserver(function () {
          if (!cart.hidden && !video.paused) video.pause();
        }).observe(cart, { attributes: true, attributeFilter: ['hidden'] });
      }
    });
  }

  function init(root) {
    if (root.dataset.ppzGallery === 'ready') return;
    root.dataset.ppzGallery = 'ready';

    var track = root.querySelector('[data-ppz-gallery-track]');
    var strip = root.querySelector('[data-ppz-gallery-thumbs]');
    if (!track) return;

    function slides() { return Array.prototype.slice.call(track.children); }
    function thumbs() {
      return strip ? Array.prototype.slice.call(strip.querySelectorAll('[data-ppz-gallery-thumb]')) : [];
    }

    wireVideos(root, track);

    if (slides().length < 2) return;

    /* offsetLeft e' relativo all'antenato posizionato, non al nastro: si
       normalizza sulla prima foto, cosi' il conto regge comunque. */
    function offsetOf(el) {
      var first = track.firstElementChild;
      return el.offsetLeft - (first ? first.offsetLeft : 0);
    }

    function currentIndex() {
      var list = slides();
      var left = track.scrollLeft;
      var best = 0;
      var bestDistance = Infinity;
      list.forEach(function (el, i) {
        var d = Math.abs(offsetOf(el) - left);
        if (d < bestDistance) { bestDistance = d; best = i; }
      });
      return best;
    }

    /* Porta la miniatura attiva dentro la striscia visibile, senza mai
       muovere la pagina: scrollIntoView farebbe saltare tutto il documento. */
    function revealThumb(el) {
      if (!strip || !el) return;
      var start = el.offsetLeft - strip.offsetLeft;
      var end = start + el.offsetWidth;
      var pad = 8;
      if (start < strip.scrollLeft) {
        strip.scrollTo({ left: Math.max(0, start - pad), behavior: 'smooth' });
      } else if (end > strip.scrollLeft + strip.clientWidth) {
        strip.scrollTo({ left: end - strip.clientWidth + pad, behavior: 'smooth' });
      }
    }

    function sync() {
      var c = currentIndex();
      var list = thumbs();
      list.forEach(function (t, i) {
        if (i === c) { t.setAttribute('aria-current', 'true'); }
        else { t.removeAttribute('aria-current'); }
      });
      revealThumb(list[c]);
    }

    /* Divide gli elementi in tre gruppi e li riattacca in quest'ordine:
       la confezione scelta, le foto senza confezione, le altre confezioni. */
    function sortNodes(nodes, units) {
      var chosen = [], plain = [], otherPacks = [];
      nodes.forEach(function (el) {
        var b = parseInt(el.getAttribute('data-bundle'), 10) || 0;
        if (b === units) chosen.push(el);
        else if (b > 0) otherPacks.push(el);
        else plain.push(el);
      });

      /* Le confezioni in fondo si rimettono sempre in ordine crescente:
         se si ordinassero come capitano nel DOM, dopo due scelte di fila
         finirebbero in un ordine diverso ogni volta. */
      otherPacks.sort(function (a, b) {
        return (parseInt(a.getAttribute('data-bundle'), 10) || 0)
             - (parseInt(b.getAttribute('data-bundle'), 10) || 0);
      });

      return chosen.concat(plain, otherPacks);
    }

    function reorder(units) {
      if (!units) return;

      sortNodes(slides(), units).forEach(function (el) { track.appendChild(el); });

      if (strip) {
        var items = Array.prototype.slice.call(strip.children);
        sortNodes(items, units).forEach(function (el) { strip.appendChild(el); });
      }

      /* Dopo il riordino si riparte dalla prima foto, che e' quella della
         confezione appena scelta: e' tutto il punto del riordino. */
      track.scrollTo({ left: 0, behavior: 'smooth' });
      if (strip) strip.scrollTo({ left: 0, behavior: 'smooth' });
      sync();
    }

    if (strip) {
      /* Un solo ascoltatore sulla striscia invece di uno per miniatura: dopo
         il riordino i bottoni sono gli stessi ma in ordine diverso, e cosi'
         non serve riagganciare niente. */
      strip.addEventListener('click', function (e) {
        var thumb = e.target.closest ? e.target.closest('[data-ppz-gallery-thumb]') : null;
        if (!thumb) return;
        var i = thumbs().indexOf(thumb);
        var target = slides()[i];
        if (target) track.scrollTo({ left: offsetOf(target), behavior: 'smooth' });
      });
    }

    root.addEventListener('ppz:bundle', function (e) {
      reorder(e.detail && e.detail.units);
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-ppz-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Il theme editor ricrea le sezioni senza ricaricare la pagina. */
  document.addEventListener('shopify:section:load', boot);
})();
